import { useState, useEffect } from "react";
import emailjs from 'emailjs-com';
import "./ContactUs.scss";
import "./ContactUs.mobile.scss";

export const ContactUs = () => {

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [success, setSuccess] = useState(false);
    const [isSending, setIsSending] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!name.trim() || !email.trim() || !message.trim()) {
            alert('Por favor, preencha todos os campos corretamente.');
            return;
        }

        const templateParams = {
            name,
            email,
            message,
        };

        setIsSending(true);
        setErrorMessage('');
        setSuccess(false);

        emailjs.send('service_jeqxxhl', 'template_3hcsrzs', templateParams, 'r-ryG_bAlWBkMQCjp')
            .then((response) => {
                console.log(response.status, response.text);
                setSuccess(true);  
                setName('');       
                setEmail('');
                setMessage('');
            })
            .catch((error) => {
                console.log('Erro ao enviar o e-mail:', error);
                setErrorMessage('Não foi possível enviar sua mensagem agora. Entre em contato pelo e-mail contato@krlservices.com.br.');
            })
            .finally(() => {
                setIsSending(false);
            });
    };

    useEffect(() => {
        if (success) {
            const timer = setTimeout(() => {
                setSuccess(false);
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [success]);

    return(
        <div className="contact-us-container" id="contact">
            <h1>Entre em contato conosco!</h1>
            <div className="form">
                <form onSubmit={handleSubmit}>
                    <span>
                        <div className="input-container">
                            <label htmlFor="contact-name">Nome: </label>
                            <input id="contact-name" type="text" name="name" onChange={(e) => setName(e.target.value)} value={name} required />
                        </div>
                        <div className="input-container">
                            <label htmlFor="contact-email">E-mail: </label>
                            <input id="contact-email" type="email" name="email" onChange={(e) => setEmail(e.target.value)} value={email} required />
                        </div>
                    </span>
                    
                    <div className="input-container">
                        <label className="input-container" htmlFor="contact-message">Mensagem: </label>
                        <textarea id="contact-message" name="message" onChange={(e) => setMessage(e.target.value)} value={message} required></textarea>
                    </div>

                    <button type="submit" disabled={isSending}>{isSending ? 'Enviando...' : 'Enviar'}</button>
                </form>
                {success && <p className="form-feedback success">Email enviado com sucesso!</p>}
                {errorMessage && (
                    <p className="form-feedback error">
                        {errorMessage} <a href="mailto:contato@krlservices.com.br">Abrir e-mail</a>
                    </p>
                )}
            </div>
        </div>
    );
};
